
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/keto",
      function () {
        return require("private-next-pages/keto/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/keto"])
      });
    }
  